// - - - - - - - - - -
// Single source of truth for the FileMaker "open this invoice" custom-URL.
//
// Uses FileMaker's `fmp://` scheme to run the KellerInteriors PresentInvoice
// script with the invoice number as its parameter — the script finds and
// displays that invoice's record in the FileMaker client. `$` = the current
// FileMaker host. This is the exact link the JobsDetailModal invoice number
// has always used; extracted here (#292 item 5) so the Ticket Master invoice
// link and the JobsDetailModal link can never drift apart.
// - - - - - - - - - -

export function getInvoiceHref(invoiceNo) {
  return `fmp://$/KellerInteriors.fmp12?script=PresentInvoice_(_invoiceNo_)&param=${invoiceNo}`;
}

// - - - - - - - - - -
// #467: the props every "open in FileMaker" invoice link uses. target="_self",
// not "_blank": the operating system hands the fmp:// link to FileMaker and the
// Scheduler page stays where it is. "_blank" opened a new browser tab that never
// had anything to show and was left behind on every click.
// - - - - - - - - - -
export const FILEMAKER_LINK_TARGET = "_self";

export function fileMakerInvoiceLinkProps(invoiceNo) {
  return { href: getInvoiceHref(invoiceNo), target: FILEMAKER_LINK_TARGET };
}
